@if (initialized && dto) {
    <div class="p-3">
        @switch (activeNavigationItem?.action) {
            @case ('agentHolidayCalendar') {
                <div class="scroll-table-container">
                    @if (widgetAgentHolidayCalendar) {
                        <mvs-widget [widgetData]="widgetAgentHolidayCalendar"></mvs-widget>
                    }
                </div>
            }
            @case ('agentPoolAgent') {
                <div class="scroll-table-container">
                    @if (widgetAgentPoolAgent) {
                        <mvs-widget [widgetData]="widgetAgentPoolAgent"></mvs-widget>
                    }
                </div>
            }
            @case ('agentScheduleWeek') {
                <div class="scroll-table-container">
                    @if (widgetAgentScheduleWeek) {
                        <mvs-widget [widgetData]="widgetAgentScheduleWeek"></mvs-widget>
                    }
                </div>
            }
            @case ('agentScheduleDay') {
                <div class="scroll-table-container">
                    @if (widgetAgentScheduleDay) {
                        <mvs-widget [widgetData]="widgetAgentScheduleDay"></mvs-widget>
                    }
                </div>
            }
            @case ('agentNumber') {
                <div class="scroll-table-container">
                    @if (widgetAgentNumber) {
                        <mvs-widget [widgetData]="widgetAgentNumber"></mvs-widget>
                    }
                </div>
            }
            @default {
                <!-- Overview: Agent base data -->
                <div class="scroll-table-container">
                    @if (widgetAgentData) {
                        <mvs-widget [widgetData]="widgetAgentData"></mvs-widget>
                    }
                </div>
            }
        }
    </div>
}
